import { Component, Input } from '@angular/core';
import { ItemToSell } from 'src/app/_services';

@Component({
  selector: 'compact-listing-description',
  templateUrl: './compact-listing-description.component.html',
  styleUrls: ['./compact-listing-description.component.scss']
})
export class CompactListingDescriptionComponent {
  
  @Input()
  item: ItemToSell;
  
  constructor() {
  }
}
